import type { ChangeEvent } from 'react'
import React, { useEffect, useRef } from 'react'
import type { StyleProp } from '@vtex/admin-ui'
import { Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router'

import {
  DrawerBody,
  DrawerFooter,
  DrawerTitle,
} from '../../../../../../ui/components'
import { useSalesAssociateCode } from '../../../../hooks/useSalesAssociateCode'
import { CheckoutButton } from '../../../../components'

export type SalesAssociateCodeContentProps = {
  isOpen?: boolean
  csx?: StyleProp
}

export const SalesAssociateCodeContent = ({
  isOpen,
}: SalesAssociateCodeContentProps) => {
  const inputSalesAssociateCodeRef = useRef<HTMLInputElement>(null)

  const history = useHistory()

  const salesAssociateCode = useSalesAssociateCode({
    onSaveCode: () => {
      history.push('./share')
    },
  })

  const handleSkipSubmit = async (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault()
    history.push('./share')
  }

  useEffect(() => {
    if (isOpen) {
      inputSalesAssociateCodeRef.current?.focus()
    }
  }, [isOpen])

  return (
    <>
      <DrawerTitle>
        <FormattedMessage id="checkout.sales-associate-code-drawer.placeholder-and-title" />
      </DrawerTitle>
      <form
        className={csx({ display: 'contents' })}
        onSubmit={
          !salesAssociateCode.code
            ? handleSkipSubmit
            : salesAssociateCode.handleSubmit
        }
      >
        <DrawerBody>
          <Text variant="action2">
            <FormattedMessage
              id={
                salesAssociateCode.salesAssociateCodeIsRequired
                  ? 'checkout.sales-associate-code-required-drawer.description'
                  : 'checkout.sales-associate-code-opcional-drawer.description'
              }
            />
          </Text>
          <div className={csx({ marginTop: '$space-6' })}>
            {salesAssociateCode.renderInput()}
          </div>
        </DrawerBody>
        <DrawerFooter>
          <CheckoutButton
            type="submit"
            size="large"
            disabled={salesAssociateCode.isContinueButtonDisabled}
            loading={salesAssociateCode.isBusy}
            className={csx({ width: 'full' })}
          >
            {salesAssociateCode.continueButtonText}
          </CheckoutButton>
        </DrawerFooter>
      </form>
    </>
  )
}
